import React from "react";
import "./key.css";

const Key = (props) => {
  return <span>{props.value}</span>;
};

export default Key;
